import BaseComponent from "../BaseComponent";

export default class TestToolNodeSubCon extends BaseComponent {
    /**
     * Submenu view for test tool node
     * @module TestToolNodeSubCon
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {
                    this.props.params.node.input && <div key="input" className="test-tool-node">
                        <p className="title">Input</p>
                        <textarea rows={8} disabled={true} value={this.props.params.node.input} />
                    </div>
                }
                {
                    this.props.params.node.output && <div key="output" className="test-tool-node">
                        <p className="title">Output</p>
                        <textarea rows={8} disabled={true} value={this.props.params.node.output} />
                    </div>
                }
            </div>
        );
    }
}